import React from 'react';
import { QuestionList, SubSection } from './styled';
import { setQuestionForSubSectionAtom } from '../atoms';
import { useSetAtom } from 'jotai';
import useHandleUserMessage from '../hooks/useHandleUserMessage';
import { CATEGORY_ICON_MAP } from '../utils';

function QuestionsSubSection({ index, section, disabled, getStream }) {
  const { title, questions } = section;
  const setQuestion = useSetAtom(setQuestionForSubSectionAtom);
  const { submitQuestion } = useHandleUserMessage({ getStream });

  const handleBtnClick = (clickedQuestionIndex) => {
    setQuestion({
      sectionIndex: index,
      clickedQuestionIndex,
    });

    submitQuestion(questions[clickedQuestionIndex]);
  };

  const Icon = CATEGORY_ICON_MAP[title];

  return (
    <SubSection>
      <div className="title" style={{ color: title === 'Analysis' ? '#4d7eff' : '#4c4c4c' }}>
        <Icon
          style={{
            width: '24px',
            display: 'inline-block',
            marginRight: '8px',
            verticalAlign: '-3px'
          }}
        />
        {title}
      </div>
      <QuestionList>
        {questions.map((question, index) => (
          <li
            key={index}
            onClick={
              disabled
                ? () => {
                    return;
                  }
                : () => handleBtnClick(index)
            }
            className={disabled ? 'disabled' : ''}
          >
            {question}
          </li>
        ))}
      </QuestionList>
    </SubSection>
  );
}

export default QuestionsSubSection;
